import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

/**
 * Directive that allows declaring a variable inside a view in Angular 2+.
 *
 * Example usage:
 * <div *ngVar="45 as variable">
 *   <span>{{variable}}</span>
 * </div>
 */
@Directive({
  selector: '' + '[ngVar]'
})
export class VarDirective {
  @Input()
  set ngVar(context: any) {
    this.context['$implicit'] = this.context['ngVar'] = context;
    this.updateView();
  }

  context = {};

  constructor(private vcRef: ViewContainerRef, private templateRef: TemplateRef<any>) {}

  updateView() {
    this.vcRef.clear();
    this.vcRef.createEmbeddedView(this.templateRef, this.context);
  }
}
